// @greenlight-spec: 59-platform-agent.md#agent-definitions-and-the-catalog
import * as React from 'react';

import { SectionCard } from '@/components/greenlight/SectionCard';

import type { AgentDef } from './fixtures';

const label = 'mb-1.5 font-mono text-[10.5px] uppercase tracking-[0.06em]';
const block =
  'whitespace-pre-wrap rounded-gl-icon border border-border bg-background px-3 py-2.5 text-[12.5px] leading-relaxed text-muted-foreground';

export function DefinitionCard({ agent }: { agent: AgentDef }): React.JSX.Element {
  const d = agent.definition;
  return (
    <SectionCard title="Definition" headerBar testId="agent-definition">
      {!d ? (
        <p className="px-4 py-3 text-[13px] text-muted-foreground">No definition in this release</p>
      ) : (
        <>
          <div className="space-y-4 px-4 py-3">
            <div>
              <div className={label}>Instructions</div>
              <div className={block}>{d.instructions}</div>
            </div>
            <div>
              <div className={label}>Trigger context</div>
              <pre className={`${block} font-mono text-[11.5px]`}>{d.context}</pre>
            </div>
            <div>
              <div className={label}>Tools</div>
              <div className="flex flex-wrap gap-1">
                {d.tools.map((t) => (
                  <span
                    key={t}
                    className="rounded-md bg-muted px-1.5 py-0.5 font-mono text-[11.5px]"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
            <dl className="grid grid-cols-2 gap-3">
              <div>
                <dt className={label}>Max turns</dt>
                <dd className="font-mono text-[13px]">{d.maxTurns}</dd>
              </div>
              <div>
                <dt className={label}>Wall clock</dt>
                <dd className="font-mono text-[13px]">{d.wallClock}</dd>
              </div>
            </dl>
          </div>
          <p className="border-t border-border px-4 py-2.5 font-mono text-[11px] text-muted-foreground">
            Definition v{d.version} · {d.path} · ships with the release, not editable here
          </p>
        </>
      )}
    </SectionCard>
  );
}
